import React from "react";
import { cn } from "../../utils/lib";

export function SquareRightArrowIcon({ className, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
      className={cn("", className)}
    >
      <path
        d="M13.4916 1.66675H6.50829C3.47496 1.66675 1.66663 3.47508 1.66663 6.50841V13.4834C1.66663 16.5251 3.47496 18.3334 6.50829 18.3334H13.4833C16.5166 18.3334 18.325 16.5251 18.325 13.4917V6.50841C18.3333 3.47508 16.525 1.66675 13.4916 1.66675Z"
        fill="white"
      />
      <path
        d="M15.4417 9.55837L11.8667 5.98337C11.625 5.74171 11.225 5.74171 10.9833 5.98337C10.7417 6.22504 10.7417 6.62504 10.9833 6.86671L13.4917 9.37504H5C4.65833 9.37504 4.375 9.65837 4.375 10C4.375 10.3417 4.65833 10.625 5 10.625H13.4917L10.9833 13.1334C10.7417 13.375 10.7417 13.775 10.9833 14.0167C11.1083 14.1417 11.2667 14.2 11.425 14.2C11.5833 14.2 11.7417 14.1417 11.8667 14.0167L15.4417 10.4417C15.5583 10.325 15.625 10.1667 15.625 10C15.625 9.83337 15.5583 9.67504 15.4417 9.55837Z"
        fill="black"
      />
    </svg>
  );
}
